module.exports = __webpack_public_path__ + "assets/02543f83b3a1d67101c675b5543887a4.mp3";